import { ListItem, Breadcrumb, ListFilter, ListSorter, ListTabHeader, ListContentType, ListSort, ListContentTypeRequest } from './lists';
import { RequestContext } from '../../types/request-context';

export enum LibraryWPSTypes {
    LibraryItem = 'atv.wps#LibraryItem'
}

export interface LibraryItem extends ListItem {
    __type: LibraryWPSTypes.LibraryItem
}

export interface LibraryStrings {
    other: string;
    seeMore: string;
    removeCancel: string;
    removeConfirm: string;
    removeWarning: string;
    removeContent: string;
    hideContent: string;
    hideModalTitle: string;
    removeModalTitle: string;
}

export interface LibraryOutput {
    landmark: Breadcrumb;
    filters: ListFilter[];
    otherLists: ListFilter[];
    sorter?: ListSorter;
    content: ListContentType;
    strings: LibraryStrings;
    debug?: object;
    tabHeaders?: ListTabHeader[];
}

export interface LibraryInput {
    context: RequestContext;
    startIndex?: number;
    sort: ListSort;
    contentType: ListContentTypeRequest;
    libraryType: LibraryType;
    myStuffTreatment?: boolean;
}

export enum LibraryType {
    Items = 'Items',
    Hidden = 'Hidden',
    Preorders = 'Preorders'
}

export enum LibraryItemState {
    VISIBLE = 'VISIBLE',
    HIDDEN = 'HIDDEN',
    REMOVED = 'REMOVED'
}

export interface LibraryStateChangeInput {
    context: RequestContext;
    titleID: string;
    token: string;
    state: LibraryItemState;
}

export interface LibraryStateChangeOutput {
    success: boolean;
    debug?: object;
}
